import { Skeleton } from '@picsart/design-system/components/Skeleton';
import MasonryGridVertical from 'components/MasonryGridVertical';
import { HorizontalContainer } from '@picsart/design-system/components/HorizontalContainer';
import useStyles from './styles';

const MasonryGridSkeleton = () => {
  const classes = useStyles();

  return (
    <HorizontalContainer>
      <MasonryGridVertical
        containerClassName={classes.skeletonRoot}
        dataTestId="templates-masonry-grid"
        columnsCount={{ Small: 2, Medium: 3, Large: 4, ExtraLarge: 5 }}
      >
        {Array.from({ length: 10 }, (_, index) => (
          <Skeleton key={index} className={classes.skeleton} />
        ))}
      </MasonryGridVertical>
    </HorizontalContainer>
  );
};

export default MasonryGridSkeleton;
